import { render, staticRenderFns } from "./FooterMenuItem.vue?vue&type=template&id=58291e70&scoped=true"
import script from "./FooterMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMenuItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterMenuItem.vue?vue&type=style&index=0&id=58291e70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58291e70",
  null
  
)

export default component.exports